<template>
  <q-dialog v-model="model">
    <q-card>
      <q-toolbar>
        <q-icon size="28px" name="login" />

        <q-toolbar-title>
          {{ $t('login_modal.login_title') }}
        </q-toolbar-title>

        <q-btn flat round dense icon="close" v-close-popup />
      </q-toolbar>
      <q-card-section class="text-center">
        <div class="text-h6 text-primary">{{ $t('login_modal.login_subtitle') }}</div>
        <div class="q-py-md">
          <q-btn class="bg-info text-primary" rounded icon="login" no-caps @click="login()"
            >{{ $t('login_modal.login_btn') }}
          </q-btn>
        </div>
        <span class="text-primary">{{ $t('login_modal.new_user') }}</span>
        <q-btn
          flat
          no-caps
          dense
          class="text-primary text-bold"
          :label="$t('login_modal.register_btn')"
          @click="register()"
        />
        <q-separator spaced />
        <span class="text-weight-bold text-primary">{{ $t('login_modal.or') }}</span>
        <div class="q-gutter-x-md q-py-md">
          <q-btn round color="white" @click="login('google')">
            <q-avatar size="40px">
              <img :src="`${baseUrl}icons/google.png`" />
            </q-avatar>
          </q-btn>
          <q-btn round color="white" @click="login('linkedin')">
            <q-avatar size="40px">
              <img :src="`${baseUrl}icons/linkedin.png`" />
            </q-avatar>
          </q-btn>
          <q-btn round color="white" @click="login('facebook')">
            <q-avatar size="40px">
              <img :src="`${baseUrl}icons/facebook.png`" />
            </q-avatar>
          </q-btn>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import { login, register } from 'src/utils/keycloakManager'

const model = defineModel<boolean>({ default: false })

const baseUrl = import.meta.env.BASE_URL
</script>
